module.exports = __webpack_public_path__ + "static/media/positive-ex.874e51bc.png";